import RadioMui from "@mui/material/Radio/Radio";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";

export const InputRootWrapper = styled(Stack)(({ theme }) => (
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "center"
    })
));

export const InputLabelWrapper = styled(Stack)(({ theme }) => (
    theme.unstable_sx({
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    })
));

export const CustomIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 32,
    height: 32,
    boxShadow: `0 0 0 1px ${theme.palette.grey[400]}`,
}));

export const CustomCheckedIcon = styled(CustomIcon)(({ theme }) => ({
    "&:before": {
        display: "block",
        width: 32,
        height: 32,
        backgroundImage: `radial-gradient(${theme.palette.primary.main},${theme.palette.primary.main} 34%,transparent 38%)`,
        content: '""',
    },
}));

export const Radio = styled(RadioMui)(({ theme }) => ({
    mr: 2,

    "&.Mui-checked span": {
        boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
    },
    "&.Mui-disabled span": {
        boxShadow: `0 0 0 1px ${theme.palette.grey[400]}`,
    },
    "&.Mui-disabled span::before": {
        backgroundImage: `radial-gradient(${theme.palette.grey[400]},${theme.palette.grey[400]} 34%,transparent 38%)`,
    },
}));

